define('Magento_Checkout/js/view/summary/abstract-total-mixin',[], function () {
    "use strict";

    return function (target) {
        return target.extend({
            /**
             * @return {*}
             */
            isFullMode: function () {
                if (!this.getTotals()) {
                    return false;
                }
                // show totals block on checkout shipping step
                return true;
            }
        });
    }
});
